import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'requirement-details',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description: 'See the details of a single requirement',
    name: 'Requirement Details',
    page: { alias: 'requirement-details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
